<template>
  <div>
    <multiselect v-if="members != null" v-model="localModel" id="ajaxMember" @input="onChange" :custom-label="memberLabel" 
      track-by="id" :placeholder="$t('project.investment.form.history.member')" open-direction="bottom"
      :options="members" :multiple="false" :searchable="true" :options-limit="300" 
      :max-height="600" :show-no-results="true" 
      v-bind:deselect-label="$t('multiselect.deselect-label')"
      v-bind:selectedLabel="$t('multiselect.selectedLabel')"
      v-bind:select-label="$t('multiselect.select-label')">
      <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
    </multiselect>
  </div>
</template>

<script>
  import {MemberServiceClient, MemberDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'MemberMultiselect',
    props: {
      members: {
        type: Array,
        default: [],
      },
      model: {},
    },
    watch: {
      model: {
        immediate: true,
        handler(newVal, oldVal) {
          this.localModel = newVal
        },
      },
    },
    data() {
      return {
        localModel: {},
      }
    },
    inject: ['$validator'],
    methods: {
      onChange(value) {
        this.$emit('update', value)
      },
      memberLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },
    },
    components: {
      multiselect: Multiselect,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/shared/multiselect/MemberMultiselect.vue